import React from 'react';
import Input from 'components/inputs/Input';
import { GlobalSettingEnum } from 'api/model';

type GlobalSettingInputProps = {
  setting: GlobalSettingEnum;
  // 'time' ger webbläsarens inbyggda tidväljare och ett "HH:mm"-värde,
  // som backend parsar med TimeOnly.TryParse (tomt = regeln av).
  type?: 'number' | 'text' | 'time';
  min?: number;
  max?: number;
  // HTML5 number-input step. Defaults to 1 (heltal) when omitted; pass 'any' or a
  // decimal (e.g. 0.5) to allow decimal values such as 2.5. Only 'any' is valid as a
  // non-numeric value, so the union is narrowed to catch typos at compile time.
  step?: number | 'any';
  // Tillåt bara heltal. step=1 räcker inte: den styr pilarna och valideringen men hindrar
  // inte att man skriver "37.5", som då sparas och som backend (int.TryParse) tyst ignorerar.
  integer?: boolean;
  disabled?: boolean;
  placeholder?: string;
  watch: (key: string) => string;
  setValue: (key: string, value: string) => void;
  handleInputChangeDebounced: (
    setting: GlobalSettingEnum,
    value: string
  ) => Promise<void>;
};

const GlobalSettingInput: React.FC<GlobalSettingInputProps> = ({
  setting,
  type = 'text',
  min,
  max,
  step,
  integer,
  disabled,
  placeholder,
  watch,
  setValue,
  handleInputChangeDebounced,
}) => {
  return (
    <Input
      disabled={disabled}
      type={type}
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
      value={watch(String(setting))}
      onKeyDown={(ev) => {
        if (integer && ['.', ',', 'e', 'E', '+', '-'].includes(ev.key)) {
          ev.preventDefault();
        }
      }}
      onChange={async (ev) => {
        const newValue = ev.currentTarget.value;
        // Fångar det onKeyDown inte ser, t.ex. inklistrade decimaltal.
        if (integer && !/^\d*$/.test(newValue)) return;
        setValue(String(setting), newValue);
        // For numeric settings, skip persisting an empty value — it isn't
        // a valid integer. Text and time settings can be cleared (empty
        // time = the rule is off).
        if (type !== 'number' || newValue.length > 0) {
          await handleInputChangeDebounced(setting, newValue);
        }
      }}
    />
  );
};

export default GlobalSettingInput;
